import React from 'react';

import { RISK_LEVEL_COLORS } from '@/components/views/Report/KimLhc/Report/Steps/Result/Constants';

import * as S from '@/components/views/Report/KimLhc/Report/Steps/Result/styles';

type RiskLevel = keyof typeof RISK_LEVEL_COLORS;

interface RiskScoreCardProps {
	title: string;
	score: number;
	riskLevel: RiskLevel;
}

export function RiskScoreCard({ title, score, riskLevel }: Readonly<RiskScoreCardProps>) {
	return (
		<S.ScoreCard>
			<S.ScoreTitle>{title}</S.ScoreTitle>
			<S.ScoreBadge style={{ backgroundColor: RISK_LEVEL_COLORS[riskLevel] }}>
				<S.ScoreValue>{score}</S.ScoreValue>
			</S.ScoreBadge>
		</S.ScoreCard>
	);
}
